module.exports = __webpack_public_path__ + "static/media/natureswall.8d38504d.jpg";